export function cn(...classes: Array<string | false | null | undefined>) {
  return classes.filter(Boolean).join(" ");
}

export function formatReadingTime(minutes: number) {
  return `${minutes} min read`;
}